import { MapCircle } from '../models/map.circle';
import { MapLatLng } from '../models/map.latlng';
import { HMapComponent } from './hmap.component';

declare var H: any;

export class HCircle extends MapCircle {
    private hMap: HMapComponent;
    public circle: any;
    private polyline: any;
    private marker: any;
    private markerText: any;

    constructor(id: number, map: any, content: string, strokeColor: string, strokeOpacity: number,
        strokeWeight: number, fillColor: string, fillOpacity: number, center: MapLatLng,
        radius: number, editable: boolean, draggable: boolean, hMap: HMapComponent) {
        super(id, map, content, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity,
            center, radius, editable, draggable);
        // Mapa en el que se inserta el circulo
        this.hMap = hMap;
        this.circle = new H.map.Circle(center, radius, {
            style: {
                strokeColor: this.hex2rgba(strokeColor, strokeOpacity),
                strokeWeight: strokeWeight,
                fillColor: this.hex2rgba(fillColor, fillOpacity),
                lineWidth: strokeWeight
            }
        });
        this.circle.draggable = draggable;
        this.circle.setData({ id: id, content: content });
        this.map.addObject(this.circle);
        // Si es editable o dragable...
        if (draggable || editable) {
            const _this = this;
            this.circle.addEventListener('pointerenter', (event: any) => {
                document.body.style.cursor = 'pointer';
            }, false);
            this.circle.addEventListener('pointerleave', (event: any) => {
                document.body.style.cursor = this.hMap.defaultCursor;
            }, false);
            // Cuando se empieza a mover el círculo
            this.circle.addEventListener('dragstart', (event: any) => {
                if (_this.polyline) {
                    _this.map.removeObject(_this.polyline);
                    _this.polyline = null;
                }
                event.stopPropagation();
            }, false);
            // Cuando se está moviendo el círculo
            this.circle.addEventListener('drag', (event: any) => {
                const pointer = event.currentPointer;
                const center = _this.map.screenToGeo(pointer.viewportX, pointer.viewportY);
                _this.circle.setCenter(center);
                if (_this.marker) {
                    _this.marker.setGeometry(center);
                }
                event.stopPropagation();
            }, false);
            // Cuando se deja caer el círculo en una posición
            this.circle.addEventListener('dragend', (event: any) => {
                // Recupero el id para ver que círculo es
                const target = event.target;
                const data = target.getData();
                if (data !== undefined) {
                    const id = data.id;
                    if (id !== undefined) {
                        const pointer = event.currentPointer;
                        const center = _this.map.screenToGeo(pointer.viewportX, pointer.viewportY);
                        const circle = _this.hMap.circleList.get(id);
                        _this.center = new MapLatLng(center.lat, center.lng);
                        _this.hMap.onCircleDragEnd(circle);
                    }
                }
                if (editable) {
                    _this.drawOutline();
                }
                event.stopPropagation();
            }, false);
            // Si es editable...
            if (editable) {
                this.drawOutline();
            }
        } else {
            this.circle.addEventListener('pointerenter', (event: any) => {
                document.body.style.cursor = 'pointer';
            }, false);
            this.circle.addEventListener('pointerleave', (event: any) => {
                document.body.style.cursor = this.hMap.defaultCursor;
            }, false);
        }
        this.setContent(content);
    }

    // Dibujo la polilinea del borde exterior y preparo los listener necesarios
    drawOutline() {
        const _this = this;
        // Creo el círculo del centro
        if (this.marker) {
            this.map.removeObject(this.marker);
        }
        this.marker = new H.map.Marker(this.circle.getCenter(), {
            // icon: new H.map.Icon('assets/images/circulo.png'),
            icon: new H.map.Icon('assets/images/circulo.png', {
                size: new H.math.Size(32, 32),
                anchor: new H.math.Point(16, 16)
            }),
            min: 0,
            max: 22
        });
        this.marker.volatility = true;
        this.marker.draggable = false;
        this.map.addObject(this.marker);
        this.marker.addEventListener('pointerenter', (event: any) => {
            document.body.style.cursor = 'pointer';
        }, false);
        // Creo una polilinea con el borde exterior del círculo
        if (this.polyline) {
            this.map.removeObject(this.polyline);
        }
        this.polyline = new H.map.Polyline(this.circle.getGeometry().getExterior(), {
            volatility: true,
            style: {
                lineWidth: 10, // Línea ancha para que sea facil pinchar sobre ella y transparente 100%
                strokeColor: this.hex2rgba(this.strokeColor, 0)
            }
        });
        this.polyline.setData({ id: this.id, content: this.content });
        // Cierro la polilinea añadiendo un punto final igual al inicial
        this.polyline.getGeometry().pushPoint(this.polyline.getGeometry().extractPoint(0));
        this.polyline.draggable = true;
        this.map.addObject(this.polyline);
        this.polyline.addEventListener('pointermove', (event: any) => {
            const pointer = event.currentPointer;
            const p1 = _this.map.screenToGeo(pointer.viewportX, pointer.viewportY);
            let angle = Math.atan2(p1.lat - _this.circle.getCenter().lat, p1.lng - _this.circle.getCenter().lng) * 180 / Math.PI;
            if (angle < 0) {
                angle = 360 + angle;
            }
            if (angle > 345 || angle <= 15) {
                document.body.style.cursor = 'ew-resize';
            } else {
                if (angle > 15 && angle <= 75) {
                    document.body.style.cursor = 'nesw-resize';
                } else {
                    if (angle > 75 && angle <= 105) {
                        document.body.style.cursor = 'ns-resize';
                    } else {
                        if (angle > 105 && angle <= 165) {
                            document.body.style.cursor = 'nwse-resize';
                        } else {
                            if (angle > 165 && angle <= 195) {
                                document.body.style.cursor = 'ew-resize';
                            } else {
                                if (angle > 195 && angle <= 255) {
                                    document.body.style.cursor = 'nesw-resize';
                                } else {
                                    if (angle > 255 && angle <= 285) {
                                        document.body.style.cursor = 'ns-resize';
                                    } else {
                                        document.body.style.cursor = 'nwse-resize';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }, false);
        // Cuando sale el cursor de círculo
        this.polyline.addEventListener('pointerleave', (event: any) => {
            document.body.style.cursor = this.hMap.defaultCursor;
        }, false);
        // Cuando se empieza a redimensionar el círculo
        this.polyline.addEventListener('dragstart', (event: any) => {
            if (_this.polyline) {
                _this.map.removeObject(_this.polyline);
                _this.polyline = null;
            }
            event.stopPropagation();
        }, false);
        // Cuando se está redimensionando el círculo
        this.polyline.addEventListener('drag', (event: any) => {
            const pointer = event.currentPointer;
            // Distancia al centro en metros
            const radius = _this.circle.getCenter().distance(_this.map.screenToGeo(pointer.viewportX, pointer.viewportY));
            _this.circle.setRadius(radius);
            event.stopPropagation();
        }, false);
        // Cuando se deja de redimensionar el círculo
        this.polyline.addEventListener('dragend', (event: any) => {
            const pointer = event.currentPointer;
            // Distancia al centro en metros
            const radius = _this.circle.getCenter().distance(_this.map.screenToGeo(pointer.viewportX, pointer.viewportY));
            // Recupero el id para ver que círculo es
            const target = event.target;
            const data = target.getData();
            if (data !== undefined) {
                const id = data.id;
                if (id !== undefined) {
                    const circle = _this.hMap.circleList.get(id);
                    _this.radius = radius;
                    _this.hMap.onCircleRadiusChanged(circle);
                }
            }
            _this.drawOutline();
            event.stopPropagation();
        }, false);
    }

    hex2rgba(hex: any, alpha = 1) {
        const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
    }

    // Borra un círculo
    remove() {
        if (this.circle) {
            this.map.removeObject(this.circle);
            this.circle = null;
        }
        if (this.marker) {
            this.map.removeObject(this.marker);
            this.marker = null;
        }
        if (this.polyline) {
            this.map.removeObject(this.polyline);
            this.polyline = null;
        }
        if (this.markerText) {
            this.map.removeObject(this.markerText);
            this.markerText = null;
        }
    }

    // Asigna el contenido que se ve al pinchar sobre un círculo
    setContent(content: string) {
        this.content = content;
        this.circle.setData({ id: this.id, content: content });
        if (this.markerText) {
            this.map.removeObject(this.markerText);
            this.markerText = null;
        }
        // Pongo el texto en el centro
        if (this.content && this.content.length > 0) {
            const width = this.content.length * 10; // Porque la fuente es de 10pt
            const iconText = '<svg width="' + width + '" height="32" xmlns="http://www.w3.org/2000/svg">' +
                '<text x="' + width / 2 + '" y="' + 10 + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                this.content + '</text></svg>';
            this.markerText = new H.map.Marker(this.center, {
                icon: new H.map.Icon(iconText, {
                    size: new H.math.Size(width, 32),
                    anchor: new H.math.Point(width / 2, 19)
                }),
                min: 0,
                max: 22,
                volatility: true,
                visible: true
            });
            this.markerText.draggable = false;
            this.markerText.setData({
                id: this.id, title: this.content, content: this.content, textMarker: this.markerText, marker: this
            });
            // Asocio el marcador de texto al marcador de imagen
            this.marker.setData({ id: this.id, title: this.content, content: this.content, marker: this, textMarker: this.markerText });
            // Añado también el marcador con la etiqueta de texto
            this.map.addObject(this.markerText);
        }
    }

    // Pone el centro
    setCenter(position: MapLatLng) {
        this.center = position;
        this.circle.setCenter(this.center);
        // Si es editable modifico tambien la polilinea del borde exterior
        if (this.editable) {
            this.drawOutline();
        }
        this.hMap.onCircleDragEnd(this); // Por compatibilidad con Google
    }

    // Pone el radio
    setRadius(radius: number) {
        this.radius = radius;
        this.circle.setRadius(radius);
        // Si es editable modifico tambien la polininea del borde exterior
        if (this.editable) {
            this.drawOutline();
        }
    }
}
